import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
export const useApprovalPolicyOptions = () => {
  const {
    t
  } = useTranslation();
  const options = useMemo(() => [{
    value: 'automatic',
    label: t('APPROVAL_POLICY.automatic.label'),
    description: t('APPROVAL_POLICY.automatic.description'),
    icon: AutorenewIcon
  }, {
    value: 'manual',
    label: t('APPROVAL_POLICY.manual.label'),
    description: t('APPROVAL_POLICY.manual.description'),
    icon: SupervisorAccountIcon
  }], [t]);
  return options;
};